const STORY = {
    BROWN_TIME:"mini-ci-manage/oapi/v1/news/import-data/single-data"//获取稿件瀏覽次數
}
export default STORY